import {kGlossaryTexts} from "../../../constants/texts";

export default function GlossaryResearchTooltip({isStrictMode}) {
    // Used in GlossaryResearchModeButton to display tooltip about
    // selected research mode

    // BUILD
    return (
        <div className="absolute top-[40px] left-1/2 -translate-x-1/2 mt-[2px]
                    hidden group-hover:block
                    bg-backgroundLight5 text-white text-[12px] leading-snug
                    px-[4px] py-[4px] rounded-[8px] shadow-md
                    w-[240px] text-center whitespace-normal
                    opacity-0 group-hover:opacity-100
                    transition-opacity ease-in duration-200
                    pointer-events-none">
            {isStrictMode
                ? kGlossaryTexts.strictSearchTooltip
                : kGlossaryTexts.flexSearchTooltip
            }
        </div>
    );
}